<template>
  <v-container grid-list-md fluid class="header-container">
    <v-layout row wrap>
      <v-flex xs12 pa-3 class="header-content text-xs-center white--text headline font-weight-medium">
        Activities
      </v-flex>
      <utility-backButton/>
      <v-flex xs12>
        <!-- Dialog card to edit/add Activity -->
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title class="text-truncate">
              Editing Activity: {{selectedActivity.Name}}
              <v-spacer/>
              <v-icon @click="cancelEdit" color="pipefishOrange" medium>mdi-close-circle-outline</v-icon>
            </v-card-title>
            <v-card-text style="padding:2px">
              <v-form ref="form" v-model="validation">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs6 pr-5>
                      <v-text-field
                        label="Activity Name"
                        v-model="selectedActivity.Name"
                        :rules="nameRules"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-checkbox
                        v-model="selectedActivity.IsActive"
                        label="Active"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs2>
                      <v-checkbox
                        v-model="selectedActivity.IsLeave"
                        label="Leave"
                      >
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        label="Code"
                        v-model="selectedActivity.Code"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        label="Project"
                        :items="displayProjects"
                        v-model="selectedActivity.project"
                        :rules="[!!selectedActivity.project || 'Project cannot be empty']"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        label="Practice"
                        :items="displayPractices"
                        v-model="selectedActivity.practice"
                        :rules="[!!selectedActivity.practice || 'Practice cannot be empty']"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs6>
                      <v-select
                        label="Statement of Work"
                        :items="displayStatements"
                        v-model="selectedActivity.statement"
                        :rules="[!!selectedActivity.statement || 'Statement cannot be empty']"
                      >
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="pipefishOrange" @click="cancelEdit">Cancel</v-btn>
              <v-btn :loading="showLoading" color="pipefishGreen" @click="saveEdit" :disabled="showLoading || !validation">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Table starts from here -->
        <v-card-title>
          <!-- <span class="title font-weight-bold"> Activities </span> -->
            <v-spacer></v-spacer>
            <div>
              <v-flex xs12>
                <v-select
                  dense
                  hide-details
                  :items="[{text: 'Active', value: false},
                  {text: 'InActive', value: true},
                  {text: 'Both', value: 'Both'}]"
                  label="Filter on"
                  v-model="filterActive"
                >
                </v-select>
              </v-flex>
            </div>
          <div>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              hide-details
              color="pipefishGreen"
            >
              <template slot="label">
                <span>Search</span>
              </template>
            </v-text-field>
          </div>
        <v-card-actions>
          <v-spacer/>
          <v-btn  left color="pipefishGreen" @click="addActivity">Add</v-btn>
        </v-card-actions>
        </v-card-title>
        Total Shown: {{displayActivities.length}}
        <v-data-table
          v-if="activities != null"
          :headers="headers"
          :items="displayActivities"
          :search="search"
          sort-icon="mdi-menu-down"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{props.item.Name}}</td>
            <td>{{props.item.Code}}</td>
            <td>{{props.item.project.Name}}</td>
            <td>{{props.item.practice.Name}}</td>
            <td> {{props.item.statement.Name}} </td>
            <td>{{props.item.IsLeave ? "yes" : "no"}}</td>
            <td>{{props.item.IsActive ? "active" : "inactive"}}</td>
            <td class="text-xs-right"><utility-editButton @edit="editActivity(props.item)"/></td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex'

var compare = function(a, b) {
  var nameA = a.Name.toUpperCase()
  var nameB = b.Name.toUpperCase()
  if(nameA < nameB) {
    return -1
  }
  if(nameA > nameB) {
    return 1
  }
  return 0

}

export default {
  data: () =>({
    filterActive: false,
    nameRules: [
      v => !!v || 'Name is required'
    ],
    validation: true,
    search:'',
    isEdit: false,
    dialog: false,
    showLoading: false,
    selectedActivity: {},
    headers: [
      {text: 'Name', value: 'Name'},
      {text: 'Code', value: 'Code', sortable: false},
      {text: 'Project', value: 'project.Name', sortable: false},
      {text: 'Practice', value: 'practice.Name'},
      {text: 'SoW', value: 'statement.Name'},
      {text: 'Leave', value: 'IsLeave'},
      {text: 'Active', value: 'IsActive'},
      {text: 'Action', value: 'action', align: 'right'}
    ]
  }),
  computed: {
    ...mapState('admin', ['activities', 'projects', 'practices', 'statements']),
    displayActivities: function() {
      return this.activities.filter(activity => activity.IsActive != this.filterActive)
    },
    displayProjects: function() {
      this.projects.sort(compare)
      // TODO: check if it should be filtered on IsActive
      return this.projects.filter(project => project.IsActive).map(project => ({text: project.Name, value: project}))
    },
    displayPractices: function() {
      this.practices.sort(compare)
      // TODO: check is it should be filtered for only active ones
      return this.practices.filter(practice => practice.IsActive).map(practice => ({text: practice.Name, value: {
        Code: practice.Code,
        IsActive: practice.IsActive,
        Name: practice.Name,
        ProjectLeadId: practice.ProjectLeadId,
        createdAt: practice.createdAt,
        id: practice.id,
        updatedAt: practice.updatedAt,
      }}))
    },
    displayStatements: function() {
      this.statements.sort(compare)
      return this.statements.filter(sow => sow.IsActive).map(statement => ({
        text: statement.Name,
        value: statement
      }))
    }
  },
  created() {
    var self = this
    // get all practices if they aren't already retreived
    if(this.activities.length == 0) {
      this.$timesheetApi.getActivities().then(response => {
        self.setActivities(response)
      })
    }
    /* get all projects */
    if(this.projects.length == 0) {
      this.$timesheetApi.getProjects().then(response => {
        self.setProjects(response)
      })
    }
    /* get all practices */
    if(this.practices.length == 0) {
      this.$timesheetApi.getPractices().then(response => {
        self.setPractices(response)
      })
    }

    if(this.statements.length == 0) {
      this.$timesheetApi.getStatements().then(response => {
        self.setStatements(response)
      })
    }
  },
  methods: {
    ...mapMutations('admin', ['setActivities', 'setProjects', 'setPractices', 'setStatements']),
    ...mapMutations('api',['setTimesheetData']),
    editActivity(activity) {
      this.isEdit = true
      this.showLoading = false
      Object.assign(this.selectedActivity, activity)
      this.dialog = true
    },
    addActivity() {
      this.isEdit = false
      this.selectedActivity = { IsLeave: false, IsActive: true}
      this.showLoading = false
      this.dialog = true
      this.$refs.form.resetValidation()
    },
    saveEdit() {
      this.showLoading = true
      var self = this
      if(this.isEdit) {
        // editing an activity
        this.$timesheetApi.updateActivity(this.selectedActivity).then(response => {
          self.$timesheetApi.getActivities().then(res => {
            self.setActivities(res)
            self.dialog = false
          })
          self.$timesheetApi.getData().then(masterData => {
            self.setTimesheetData(masterData)
          })
        })
      } else {
        // creating a new activity
        this.$timesheetApi.addActivity(this.selectedActivity).then(response => {
          self.$timesheetApi.getActivities().then(res => {
            self.setActivities(res)
            self.dialog = false
          })
          self.$timesheetApi.getData().then(masterData => {
            self.setTimesheetData(masterData)
          })
        })
      }
    },
    cancelEdit() {
      this.dialog = false
    }
  }

}
</script>

<style>

</style>
